import { Typography } from "@suraasa/placebo-ui"

import Alert from "./Alert"
import CameraOverlay from "./CameraOverlay"
import FullscreenOverlay from "./FullscreenOverlay"

type Props = {
  /**
   * Close handler
   */
  onClose: (type: "fullscreen" | "tabUnfocus" | "devtools") => void
  /**
   * Controls whether the "Change your settings" overlay should be displayed
   */
  showSettingsOverlay: boolean
  /**
   * Controls if the Devtools warning dialog should be displayed
   */
  showDevToolsDialog: boolean
  /**
   * Controls if the "Close devtools" overlay should be displayed
   */
  showDevToolsOverlay: boolean
  /**
   * Controls if the "Enable fullscreen" overlay should be displayed
   */
  showFullscreenOverlay: boolean
  /**
   * Controls if the unfocus warning dialog should be displayed
   */
  showTabUnfocusDialog: boolean
  /**
   * Total warning count. Test will end if it exceeds `maxWarningCount`
   */
  totalWarnings: number
  /**
   * Maximum warnings allowed
   */
  maxWarningCount: number | null
  /**
   * If `true` then no alerts are shown
   */
  disabled?: boolean
  /**
   * to know if its an olympiad or assessment
   */
}

const ProctoringAlerts = ({
  maxWarningCount,
  disabled,
  onClose,
  showSettingsOverlay,
  showFullscreenOverlay,
  showTabUnfocusDialog,
}: Props) => {
  if (!maxWarningCount) return null
  if (disabled) return null

  if (showSettingsOverlay) return <CameraOverlay />

  if (showTabUnfocusDialog)
    return (
      <Alert
        onClose={() => onClose("tabUnfocus")}
        isOpen={showTabUnfocusDialog}
        title="Window Switch Detected!"
        content={
          <>
            <Typography>
              It looks like you&apos;ve switched away from the test window. For
              security reasons, please return to the test and avoid switching
              tabs or applications.
            </Typography>
            <Typography className="mt-1">
              Continued switching may trigger warnings or end this assessment.
            </Typography>
          </>
        }
      />
    )

  if (showFullscreenOverlay)
    return <FullscreenOverlay onContinue={() => onClose("fullscreen")} />

  // return (
  //   <>
  //     <UnFairMeansAlert
  //       isOpen={showUnfairMeansDialog}
  //       title="Unfair means detected!"
  //       onClose={() => onClose("unfairMeans")}
  //     />
  //     <NoFaceDetectedAlert
  //       isOpen={showNoFaceDialog}
  //       title="Are you there?"
  //       onClose={() => onClose("noFace")}
  //     />
  //   </>
  // )
}

export default ProctoringAlerts
